<template>
    <v-textarea
        v-model="currentValue"
        v-show="!hiddenField(access)"
        autocomplete="off"
        auto-grow
        :id="id"
        :label="label"
        :type="fieldTextType(dataType)"
        :required="requiredField(access)"
        :readonly="readonlyField(access)"
        :prefix="prefix"
        :suffix="suffix"
        :filled="readonlyField(access) || queryFlag"
        :rules="rules"
        :rows="1"
        :outlined="true"
        :hide-details="queryFlag"
        :dense="queryFlag"
        @input="() => handleChange(null)"
        class="code"
        persistent-counter
    >
    </v-textarea>
</template>

<script>

export default {
    name: "SnippetField",
    props: [
        "label",
        "value",
        "access",
        "pattern",
        "id",
        "name",
        "prefix",
        "suffix",
        "rules",
        "dataType",
        "queryFlag",
        "customStyle",
        "coordinates",
    ],
    data() {
        return {
            defaultValue: this.value,
            currentValue: this.value,
        };
    },
    methods: {
        handleChange(autoSource) {
            const data = {
                value: this.currentValue,
                id: this.id,
                autoSource, //: this.autoSource,
                coordinates: this.coordinates,
            };
            this.$emit("field-change", data);
        },
        setValue(value, autoSource) {
            this.currentValue = value;
            //this.autoSource = autoSource;
            this.handleChange(autoSource);
        },
    },
};
</script>

<style scoped>
.custom-snippet-style >>> .v-text-field__slot label {
    color: var(--label-color);
    background-color: var(--label-background-color);
    font-size: var(--label-size);
    border: var(--label-border);
    border-radius: var(--label-border-radius);
}
.custom-snippet-style >>> .v-text-field__slot textarea {
    color: var(--input-color);
    background-color: var(--input-background-color);
    font-size: var(--input-size);
    border: var(--input-border);
    border-radius: var(--input-border-radius);
}
.custom-snippet-style >>> .v-text-field__slot .v-text-field__prefix {
    color: var(--prefix-color);
    background-color: var(--prefix-background-color);
    font-size: var(--prefix-size);
    border: var(--prefix-border);
    border-radius: var(--prefix-border-radius);
}
.custom-snippet-style >>> .v-text-field__slot {
    color: var(--slot-color);
    background-color: var(--slot-background-color);
    font-size: var(--slot-size);
    padding: var(--slot-padding);
    margin: var(--slot-margin);
    border: var(--slot-border);
    border-radius: var(--slot-border-radius);
}

.custom-snippet-style {
    color: var(--field-color);
    background-color: var(--field-background-color);
    font-size: var(--field-size);
    padding: var(--field-padding);
    margin: var(--field-margin);
    border: var(--field-border);
    border-radius: var(--field-border-radius);
}

.code {
    font-family: "Courier New", Courier, monospace;
    font-size: 10px;
    text-overflow: ellipsis;
}

</style>